import { render, staticRenderFns } from "./FormControlPrimaryTooltip.vue?vue&type=template&id=77b737a5"
import script from "./FormControlPrimaryTooltip.vue?vue&type=script&lang=js"
export * from "./FormControlPrimaryTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports